import { FC } from 'react';
import { AccordionDetails as MuiAccordionDetails, AccordionDetailsProps } from '@mui/material';
import { clsx } from '../../utils';
import { accordionDetailsStyles } from './accordion.styles';

export const AccordionDetails: FC<AccordionDetailsProps> = ({ children, sx, ...props }) => (
	<MuiAccordionDetails {...props} sx={clsx(accordionDetailsStyles, sx)}>
		{children}
	</MuiAccordionDetails>
);
